module.exports = __webpack_public_path__ + "static/media/Oby.0ab6be04.jpg";